module.exports = __webpack_public_path__ + "img/icon6.451a28f1.svg";